module.exports = __webpack_public_path__ + "media/budapest/bastion-e9258724.jpg";